module.exports = __webpack_public_path__ + "img/icon-graph.89e11e80.png";